<template>
  <div class="bind-page">
    <!-- 导航栏 -->
    <div class="nav-header">
      <div class="nav-back" @click="back">
        <van-icon name="arrow-left" />
      </div>
      <div class="nav-title">{{$t('withdrawAccountRegister')}}</div>
    </div>

    <!-- 表单内容 -->
    <div class="form-content">
      <!-- 银行选择 -->
      <div class="input-card" @click="showBankPicker = true">
        <div class="input-label">{{$t('selectBankCard')}}</div>
        <div class="bank-display">
          <span class="bank-text">{{ selectedBankText || $t('selectBankCard') }}</span>
          <van-icon name="arrow-down" class="bank-arrow" />
        </div>
      </div>

      <!-- 银行卡号 -->
      <div class="input-card">
        <div class="input-label">{{$t('accountNumber')}}</div>
        <van-field 
          v-model="bankid" 
          type="digit" 
          :placeholder="$t('enterBankCardNumber')"
          class="input-field"
          borderless
        />
      </div>

      <!-- 账户持有人 -->
      <div class="input-card">
        <div class="input-label">{{$t('accountHolder')}}</div>
        <van-field 
          v-model="bankname" 
          type="text" 
          :placeholder="$t('enterRealName')"
          class="input-field"
          borderless
        />
      </div>

      <!-- 提现密码 -->
      <div class="input-card">
        <div class="input-label">{{$t('withdrawPassword')}}</div>
        <van-field 
          v-model="password" 
          type="password" 
          :placeholder="$t('registerWithdrawPassword')"
          class="input-field"
          borderless
        />
      </div>

      <!-- 提交按钮 -->
      <button class="submit-btn" @click="bindCard">
        {{$t('common.addbank')}}
      </button>
    </div>

    <!-- 国际版银行选择器 - Action Sheet 方式 -->
    <van-action-sheet 
      v-model="showBankPicker" 
      :title="$t('selectBankCard')"
      class="bank-action-sheet"
    >
      <div class="bank-list">
        <div
          v-for="bank in banks"
          :key="bank.value"
          class="bank-item"
          :class="{ 'bank-item--selected': bank.value === bank }"
          @click="selectBank(bank)"
        >
          <div class="bank-item-content">
            <div class="bank-icon">
              <van-icon name="credit-pay" />
            </div>
            <div class="bank-info">
              <div class="bank-name">{{ bank.text }}</div>
              <div class="bank-code" v-if="bank.code">{{ bank.code }}</div>
            </div>
            <div class="bank-check" v-if="bank.value === bank">
              <van-icon name="success" />
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <!-- 或者使用国际版 Picker -->
    <van-popup 
      v-model="showBankPicker2" 
      position="bottom" 
      round
      class="bank-picker-popup"
    >
      <van-picker
        :title="$t('selectBankCard')"
        show-toolbar
        :columns="bankColumns"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onBankConfirm"
        @cancel="showBankPicker2 = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'BindCard',
  data() {
    return {
      banks: [],
      bankColumns: [],
      showBankPicker: false,
      showBankPicker2: false, // 第二个选择器，可以根据需要选择使用哪个
      userInfo: {},
      bankid: "",
      bankname: '',
      password: '',
      bank: ""
    };
  },
  computed: {
    selectedBankText() {
      if (!this.bank) return '';
      const selected = this.banks.find(item => item.value === this.bank);
      return selected ? selected.text : '';
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    
    // Action Sheet 选择方式
    selectBank(selectedBank) {
      this.bank = selectedBank.value;
      this.showBankPicker = false;
    },
    
    // Picker 选择方式
    onBankConfirm(value) {
      const selectedBank = this.banks.find(item => item.text === value);
      if (selectedBank) {
        this.bank = selectedBank.value;
      }
      this.showBankPicker2 = false;
    },
    
    bindCard() {
      if (!this.bankid) {
        this.$toast(this.$t('enterBankCardNumber'));
        return;
      }
      
      if (!this.bank) {
        this.$toast.fail(this.$t('selectBankCard'));
        return;
      }
      
      if (!this.bankname) {
        this.$toast.fail(this.$t('enterRealName'));
        return;
      }
      
      if (!this.password) {
        this.$toast.fail(this.$t('registerWithdrawPassword'));
        return;
      }

      this.$http({
        method: 'post',
        data: {
          bankid: this.bankid,
          bank: this.bank,
          bankname: this.bankname,
          password: this.password
        },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          setTimeout(() => {
            this.$router.push('/Mine');
          }, 1000);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).catch(error => {
        console.error('绑定银行卡失败:', error);
        this.$toast.fail(this.$t('common.operationFailed'));
      });
    },
    
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    
    getBankList() {
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res => {
        if (res.code === 200) {
          this.banks = res.data;
          this.bankColumns = this.banks.map(item => item.text);
          // 设置默认选择第一个银行
          if (this.banks.length > 0) {
            this.bank = this.banks[0].value;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          // 处理银行信息
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/Login');
    } else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang="less" scoped>
.bind-page {
  min-height: 100vh;
  background: #f5f6fa;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  font-size: 26px;
}

/* 导航栏 */
.nav-header {
  height: 80px;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  display: flex;
  align-items: center;
  padding: 0 24px;
  position: relative;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}

.nav-back {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .van-icon {
    font-size: 32px;
    color: #fff;
  }
}

.nav-title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 600;
  margin-right: 80px;
}

/* 表单内容 */
.form-content {
  padding: 32px 24px;
}

/* 输入卡片 */
.input-card {
  background: #fff;
  border: 2px solid #e8e8e8;
  border-radius: 20px;
  margin-bottom: 28px;
  padding: 28px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  
  &:active {
    background: #f8f9ff;
    border-color: #667eea;
  }
}

.input-label {
  font-size: 26px;
  color: #333;
  font-weight: 500;
  margin-bottom: 22px;
}

/* 银行选择显示 */
.bank-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
}

.bank-text {
  font-size: 26px;
  color: #333;
  
  &:empty::before {
    content: attr(data-placeholder);
    color: #999;
    font-size: 26px;
  }
}

.bank-arrow {
  font-size: 26px;
  color: #999;
}

/* 输入框 */
.input-field {
  padding: 0;
  background: #fff;
  
  ::v-deep .van-field__body {
    padding: 0;
  }
  
  ::v-deep .van-field__control {
    font-size: 26px;
    color: #333;
    padding: 18px 0;
    min-height: 44px;
    
    &::placeholder {
      color: #999;
      font-size: 24px;
    }
  }
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  height: 80px;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 28px;
  font-weight: 600;
  margin-top: 36px;
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.3);
  transition: all 0.2s ease;
  
  &:active {
    transform: scale(0.98);
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  }
}

/* 国际版 Action Sheet 选择器样式 */
::v-deep .bank-action-sheet {
  .van-action-sheet__header {
    font-size: 28px;
    font-weight: 600;
    padding: 28px 24px;
    color: #333;
    border-bottom: 2px solid #f0f0f0;
  }
  
  .van-action-sheet__content {
    max-height: 60vh;
    overflow-y: auto;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  
  .van-action-sheet__close {
    font-size: 28px;
    color: #667eea;
  }
}

.bank-list {
  padding: 0 24px 24px;
}

.bank-item {
  padding: 24px 0;
  border-bottom: 2px solid #f8f9fa;
  
  &:last-child {
    border-bottom: none;
  }
  
  &--selected {
    .bank-name {
      color: #667eea;
      font-weight: 600;
    }
    
    .bank-check {
      color: #667eea;
    }
  }
  
  &:active {
    background-color: #f8f9ff;
  }
}

.bank-item-content {
  display: flex;
  align-items: center;
}

.bank-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #3498db, #8e44ad);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  
  .van-icon {
    font-size: 28px;
    color: #fff;
  }
}

.bank-info {
  flex: 1;
}

.bank-name {
  font-size: 26px;
  color: #333;
  font-weight: 500;
  margin-bottom: 6px;
}

.bank-code {
  font-size: 22px;
  color: #999;
}

.bank-check {
  .van-icon {
    font-size: 32px;
    color: #ccc;
  }
}

/* 国际版 Picker 选择器样式 */
::v-deep .bank-picker-popup {
  .van-picker {
    background: #fff;
    
    .van-picker__toolbar {
      height: 80px;
      border-bottom: 2px solid #f0f0f0;
    }
    
    .van-picker__confirm,
    .van-picker__cancel {
      font-size: 26px;
      color: #667eea;
      padding: 0 28px;
      font-weight: 500;
    }
    
    .van-picker__cancel {
      color: #999;
    }
    
    .van-picker__title {
      font-size: 26px;
      color: #333;
      font-weight: 600;
    }
    
    .van-picker-column__item {
      font-size: 26px;
      color: #333;
      height: 80px;
      line-height: 80px;
    }
    
    .van-picker-column__item--selected {
      color: #667eea;
      font-weight: 600;
      font-size: 28px;
    }
  }
}

/* 响应式适配 */
@media (max-width: 375px) {
  .bind-page {
    font-size: 24px;
  }
  
  .form-content {
    padding: 28px 20px;
  }
  
  .input-card {
    padding: 24px;
    margin-bottom: 24px;
    border-radius: 18px;
  }
  
  .input-label {
    font-size: 24px;
  }
  
  .bank-text {
    font-size: 24px;
  }
  
  .input-field ::v-deep .van-field__control {
    font-size: 24px;
    
    &::placeholder {
      font-size: 22px;
    }
  }
  
  .submit-btn {
    height: 72px;
    font-size: 26px;
    border-radius: 18px;
  }
  
  .nav-header {
    height: 72px;
  }
  
  .nav-title {
    font-size: 26px;
  }
  
  /* Action Sheet 响应式 */
  ::v-deep .bank-action-sheet {
    .van-action-sheet__header {
      font-size: 26px;
      padding: 24px 20px;
    }
  }
  
  .bank-icon {
    width: 56px;
    height: 56px;
    
    .van-icon {
      font-size: 26px;
    }
  }
  
  .bank-name {
    font-size: 24px;
  }
}

/* 动画效果 */
.input-card {
  animation: slideUp 0.4s ease-out forwards;
  opacity: 0;
  transform: translateY(20px);
  
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
}

.submit-btn {
  animation: slideUp 0.4s ease-out 0.5s forwards;
  opacity: 0;
  transform: translateY(20px);
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bind-page {
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.input-field ::v-deep .van-field__control {
  user-select: text;
}

.input-card:active {
  border-color: #667eea;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
}

/* Override the legacy <=375px rule, whose fixed 24-26px type is too large. */
@media (max-width: 430px) {
  .bind-page {
    width: 100%;
    min-width: 0;
    min-height: 100svh;
    overflow-x: hidden;
    font-size: 16px;
  }

  .nav-header {
    width: 100%;
    height: auto;
    min-height: 56px;
    padding: env(safe-area-inset-top) 12px 0;
  }

  .nav-back {
    width: 44px;
    height: 52px;
    flex: 0 0 44px;
  }

  .nav-back .van-icon {
    font-size: 22px;
  }

  .nav-title {
    min-width: 0;
    margin-right: 44px;
    padding: 8px 3px;
    font-size: 17px;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }

  .form-content {
    min-width: 0;
    padding: 16px 12px max(22px, env(safe-area-inset-bottom));
  }

  .input-card {
    min-width: 0;
    margin-bottom: 13px;
    padding: 16px 14px;
    border-width: 1px;
    border-radius: 14px;
  }

  .input-label {
    margin-bottom: 9px;
    font-size: 15px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .bank-display {
    min-width: 0;
    gap: 8px;
    padding: 8px 0;
  }

  .bank-text {
    min-width: 0;
    flex: 1;
    font-size: 16px;
    line-height: 1.35;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .bank-arrow {
    flex: 0 0 auto;
    font-size: 18px;
  }

  .input-field,
  .input-field ::v-deep .van-field__value,
  .input-field ::v-deep .van-field__body,
  .input-field ::v-deep .van-field__control {
    min-width: 0;
  }

  .input-field ::v-deep .van-field__control {
    min-height: 44px;
    padding: 9px 0;
    font-size: 16px;
  }

  .input-field ::v-deep .van-field__control::placeholder {
    font-size: 14px;
  }

  .submit-btn {
    height: auto;
    min-height: 52px;
    margin-top: 18px;
    padding: 10px 12px;
    border-radius: 14px;
    font-size: 16px;
    line-height: 1.35;
    white-space: normal;
  }

  ::v-deep .bank-action-sheet {
    width: 100%;
    max-height: min(82svh, 640px);
  }

  ::v-deep .bank-action-sheet .van-action-sheet__header {
    min-height: 54px;
    padding: 15px 46px;
    font-size: 17px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  ::v-deep .bank-action-sheet .van-action-sheet__close {
    font-size: 22px;
  }

  .bank-list {
    min-width: 0;
    padding: 0 14px max(14px, env(safe-area-inset-bottom));
  }

  .bank-item {
    min-width: 0;
    padding: 13px 0;
  }

  .bank-item-content,
  .bank-info {
    min-width: 0;
  }

  .bank-icon {
    width: 44px;
    height: 44px;
    margin-right: 11px;
    border-radius: 12px;
  }

  .bank-icon .van-icon {
    font-size: 21px;
  }

  .bank-name {
    font-size: 16px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .bank-code {
    font-size: 13px;
    overflow-wrap: anywhere;
  }

  ::v-deep .bank-picker-popup .van-picker .van-picker__toolbar {
    height: 54px;
  }

  ::v-deep .bank-picker-popup .van-picker .van-picker__confirm,
  ::v-deep .bank-picker-popup .van-picker .van-picker__cancel,
  ::v-deep .bank-picker-popup .van-picker .van-picker__title,
  ::v-deep .bank-picker-popup .van-picker .van-picker-column__item {
    font-size: 16px;
  }

  ::v-deep .bank-picker-popup .van-picker .van-picker-column__item {
    height: 48px;
    line-height: 48px;
  }
}

@media (max-width: 340px) {
  .form-content {
    padding-right: 9px;
    padding-left: 9px;
  }

  .input-card {
    padding-right: 12px;
    padding-left: 12px;
  }

  .nav-title {
    font-size: 15px;
  }
}
</style>